// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603111504/js/" + chunkId + "." + {"44":"c434f91c","225":"d17ae190","481":"f02acc4f","486":"0e692f57","770":"42fb55e0"}[chunkId] + ".0.3264993162913321.chunk.js";
};